export type AnalyticsEvent =
  | "Signup Started"
  | "Login Opened"
  | "Contact Opened"
  | "Meeting Opened"
  | "Migration Requested"
  | "Early Access Opened"
  | "Pricing CTA Clicked";

type EventProps = Record<string, string | number | boolean>;

declare global {
  interface Window {
    plausible?: ((event: string, options?: { props?: EventProps }) => void) & {
      q?: unknown[];
    };
  }
}

export const trackEvent = (event: AnalyticsEvent, props: EventProps = {}) => {
  if (typeof window === "undefined" || typeof window.plausible !== "function") return;
  window.plausible(event, { props });
};

const getElement = (target: EventTarget | null) =>
  target instanceof Element ? target.closest<HTMLElement>("[data-track-event]") : null;

export const installAnalyticsTracking = () => {
  if (typeof document === "undefined") return () => undefined;

  const handleClick = (event: MouseEvent) => {
    const element = getElement(event.target);
    if (!element) return;

    const name = element.dataset.trackEvent as AnalyticsEvent | undefined;
    if (!name) return;

    const href = element instanceof HTMLAnchorElement ? element.href : "";
    trackEvent(name, {
      placement: element.dataset.trackPlacement || "unknown",
      ...(element.dataset.trackPlan ? { plan: element.dataset.trackPlan } : {}),
      ...(href ? { destination: href } : {}),
    });
  };

  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
};
